<template>
  <div>
    <b-card v-if="loading" class="text-center py-5">
      <b-spinner variant="primary" />
    </b-card>

    <b-card v-else-if="!reports.length" class="text-center py-5">
      <p class="text-muted mb-0">Nenhum relatório disponível para seu perfil.</p>
    </b-card>

    <div v-else class="row match-height">
      <div
        v-for="report in reports"
        :key="report.key"
        class="col-sm-6 col-md-4 col-lg-3"
      >
        <b-card
          class="bi-report-card cursor-pointer h-100"
          @click="$router.push({ name: 'bi-report-view', params: { key: report.key } })"
        >
          <div class="d-flex align-items-center">
            <div class="avatar bg-light-primary mr-1 rounded">
              <feather-icon icon="BarChart2Icon" size="20" class="text-primary" />
            </div>
            <div class="overflow-hidden">
              <p class="mb-0 font-weight-bold text-body text-truncate">{{ report.title }}</p>
              <small class="text-muted">Looker Studio</small>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'BiReportList',
  data() {
    return {
      reports: [],
      loading: true,
    }
  },
  async created() {
    try {
      const { data } = await axios.get('api/bi-reports')
      this.reports = data
    } catch {
      this.reports = []
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.bi-report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.15);
  transition: all 0.2s;
}
</style>
